import { pick } from 'ramda';

export default pick(['disabled', 'label', 'selected', 'value']);
